import { render, staticRenderFns } from "./StaticCard.vue?vue&type=template&id=dc9a6280&"
import script from "./StaticCard.vue?vue&type=script&lang=js&"
export * from "./StaticCard.vue?vue&type=script&lang=js&"
import style0 from "./StaticCard.vue?vue&type=style&index=0&id=dc9a6280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports